"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.proposalsTypes = exports.DiscussionPost = exports.DiscussionThread = exports.ThreadMode = exports.PostAuthorId = exports.ThreadAuthorId = exports.ProposalDetails = exports.FundingRequestParameters = exports.TerminateRoleParameters = exports.FillOpeningParameters = exports.CreateOpeningParameters = exports.GeneralProposalParameters = exports.ProposalCreationParameters = exports.Proposal = exports.SetLead = exports.SetLeadParams = exports.SpendingParams = exports.ProposalId = exports.VoteKind = exports.VoteKindDef = exports.VoteKinds = exports.ExecutionStatus = exports.ProposalStatus = exports.PendingConstitutionality = exports.PendingExecution = exports.Active = exports.ProposalDecision = exports.ProposalDecisionDef = exports.Approved = exports.ApprovedProposalDecision = exports.ApprovedProposalDecisionDef = exports.ExecutionFailed = exports.ExecutionFailedStatus = exports.IProposalStatus = exports.ProposalParameters = exports.VotingResults = void 0;
// TODO: FIXME: Use Bytes instead of Text to avoid issues with type decoding (ie. 0x909090)
// (or investigate ways of mitigating this by creating a PR to @polkadot/api library)
const types_1 = require("@polkadot/types");
const common_1 = require("./common");
const working_group_1 = require("./working-group");
class VotingResults extends (0, common_1.JoyStructDecorated)({
    abstensions: types_1.u32,
    approvals: types_1.u32,
    rejections: types_1.u32,
    slashes: types_1.u32,
}) {
}
exports.VotingResults = VotingResults;
class ProposalParameters extends (0, common_1.JoyStructDecorated)({
    votingPeriod: types_1.u32,
    gracePeriod: types_1.u32,
    approvalQuorumPercentage: types_1.u32,
    approvalThresholdPercentage: types_1.u32,
    slashingQuorumPercentage: types_1.u32,
    slashingThresholdPercentage: types_1.u32,
    requiredStake: types_1.Option.with(types_1.u128),
    constitutionality: types_1.u32,
}) {
}
exports.ProposalParameters = ProposalParameters;
exports.IProposalStatus = {
    Active: 'Active',
    Canceled: 'Canceled',
    Expired: 'Expired',
    Approved: 'Approved',
    Rejected: 'Rejected',
    Vetoed: 'Vetoed',
    PendingExecution: 'PendingExecution',
    Executed: 'Executed',
    ExecutionFailed: 'ExecutionFailed',
    Finalized: 'Finalized',
    Slashed: 'Slashed',
};
class ExecutionFailedStatus extends (0, common_1.JoyStructDecorated)({
    error: types_1.Text,
}) {
}
exports.ExecutionFailedStatus = ExecutionFailedStatus;
class ExecutionFailed extends ExecutionFailedStatus {
}
exports.ExecutionFailed = ExecutionFailed;
exports.ApprovedProposalDecisionDef = {
    PendingExecution: types_1.Null,
    PendingConstitutionality: types_1.Null,
};
class ApprovedProposalDecision extends (0, common_1.JoyEnum)(exports.ApprovedProposalDecisionDef) {
}
exports.ApprovedProposalDecision = ApprovedProposalDecision;
class Approved extends ApprovedProposalDecision {
}
exports.Approved = Approved;
exports.ProposalDecisionDef = {
    Canceled: types_1.Null,
    CanceledByRuntime: types_1.Null,
    Vetoed: types_1.Null,
    Rejected: types_1.Null,
    Slashed: types_1.Null,
    Expired: types_1.Null,
    Approved,
};
class ProposalDecision extends (0, common_1.JoyEnum)(exports.ProposalDecisionDef) {
}
exports.ProposalDecision = ProposalDecision;
class Active extends types_1.Null {
}
exports.Active = Active;
class PendingExecution extends types_1.u32 {
}
exports.PendingExecution = PendingExecution;
class PendingConstitutionality extends types_1.Null {
}
exports.PendingConstitutionality = PendingConstitutionality;
class ProposalStatus extends (0, common_1.JoyEnum)({
    Active,
    PendingExecution,
    PendingConstitutionality,
}) {
}
exports.ProposalStatus = ProposalStatus;
class ExecutionStatus extends (0, common_1.JoyEnum)({
    Executed: types_1.Null,
    ExecutionFailed,
}) {
}
exports.ExecutionStatus = ExecutionStatus;
exports.VoteKinds = ['Approve', 'Reject', 'Slash', 'Abstain'];
exports.VoteKindDef = {
    Approve: types_1.Null,
    Reject: types_1.Null,
    Slash: types_1.Null,
    Abstain: types_1.Null,
};
class VoteKind extends (0, common_1.JoyEnum)(exports.VoteKindDef) {
}
exports.VoteKind = VoteKind;
class ProposalId extends types_1.u32 {
}
exports.ProposalId = ProposalId;
class SpendingParams extends types_1.Tuple.with(['Balance', 'AccountId']) {
}
exports.SpendingParams = SpendingParams;
class SetLeadParams extends types_1.Tuple.with([common_1.MemberId, common_1.AccountId]) {
}
exports.SetLeadParams = SetLeadParams;
class SetLead extends types_1.Option.with(SetLeadParams) {
}
exports.SetLead = SetLead;
class Proposal
// FIXME: Snake case for consistency?
 extends (0, common_1.JoyStructDecorated)({
    parameters: ProposalParameters,
    proposerId: common_1.MemberId,
    activatedAt: types_1.u32,
    status: ProposalStatus,
    votingResults: VotingResults,
    exactExecutionBlock: types_1.Option.with(types_1.u32),
    nrOfCouncilConfirmations: types_1.u32,
    stakingAccountId: types_1.Option.with(common_1.AccountId),
}) {
}
exports.Proposal = Proposal;
class ProposalCreationParameters extends (0, common_1.JoyStructDecorated)({
    account_id: common_1.AccountId,
    proposer_id: common_1.MemberId,
    proposal_parameters: ProposalParameters,
    title: types_1.Text,
    description: types_1.Text,
    staking_account_id: types_1.Option.with(common_1.AccountId),
    encoded_dispatchable_call_code: types_1.Vec.with(types_1.u8),
    exact_execution_block: types_1.Option.with(types_1.u32),
}) {
}
exports.ProposalCreationParameters = ProposalCreationParameters;
class GeneralProposalParameters extends (0, common_1.JoyStructDecorated)({
    member_id: common_1.MemberId,
    title: types_1.Text,
    description: types_1.Text,
    staking_account_id: types_1.Option.with(common_1.AccountId),
    exact_execution_block: types_1.Option.with(types_1.u32),
}) {
}
exports.GeneralProposalParameters = GeneralProposalParameters;
class CreateOpeningParameters extends (0, common_1.JoyStructDecorated)({
    description: types_1.Bytes,
    stake_policy: working_group_1.StakePolicy,
    reward_per_block: types_1.Option.with(types_1.u128),
    working_group: common_1.WorkingGroup,
}) {
}
exports.CreateOpeningParameters = CreateOpeningParameters;
class FillOpeningParameters extends (0, common_1.JoyStructDecorated)({
    opening_id: working_group_1.OpeningId,
    successful_application_id: working_group_1.ApplicationId,
    working_group: common_1.WorkingGroup,
}) {
}
exports.FillOpeningParameters = FillOpeningParameters;
class TerminateRoleParameters extends (0, common_1.JoyStructDecorated)({
    worker_id: working_group_1.WorkerId,
    slashing_amount: types_1.Option.with(types_1.u128),
    working_group: common_1.WorkingGroup,
}) {
}
exports.TerminateRoleParameters = TerminateRoleParameters;
class FundingRequestParameters extends (0, common_1.JoyStructDecorated)({
    account: common_1.AccountId,
    amount: types_1.u128,
}) {
}
exports.FundingRequestParameters = FundingRequestParameters;
// Typesafe tuple workarounds
const UpdateWorkingGroupBudget = types_1.Tuple.with(['Balance', common_1.WorkingGroup, common_1.BalanceKind]);
const DecreaseWorkingGroupLeadStake = types_1.Tuple.with([working_group_1.WorkerId, 'Balance', common_1.WorkingGroup]);
const SlashWorkingGroupLead = types_1.Tuple.with([working_group_1.WorkerId, 'Balance', common_1.WorkingGroup]);
const SetWorkingGroupLeadReward = types_1.Tuple.with([working_group_1.WorkerId, 'Option<Balance>', common_1.WorkingGroup]);
const CancelWorkingGroupLeadOpening = types_1.Tuple.with([working_group_1.OpeningId, common_1.WorkingGroup]);
const CreateBlogPost = types_1.Tuple.with([types_1.Text, types_1.Text]);
const EditBlogPost = types_1.Tuple.with([common_1.PostId, 'Option<Text>', 'Option<Text>']);
class ProposalDetails extends (0, common_1.JoyEnum)({
    Signal: types_1.Text,
    RuntimeUpgrade: types_1.Bytes,
    FundingRequest: types_1.Vec.with(FundingRequestParameters),
    SetMaxValidatorCount: types_1.u32,
    CreateWorkingGroupLeadOpening: CreateOpeningParameters,
    FillWorkingGroupLeadOpening: FillOpeningParameters,
    UpdateWorkingGroupBudget,
    DecreaseWorkingGroupLeadStake,
    SlashWorkingGroupLead,
    SetWorkingGroupLeadReward,
    TerminateWorkingGroupLead: TerminateRoleParameters,
    AmendConstitution: types_1.Text,
    CancelWorkingGroupLeadOpening,
    SetMembershipPrice: types_1.u128,
    SetCouncilBudgetIncrement: types_1.u128,
    SetCouncilorReward: types_1.u128,
    SetInitialInvitationBalance: types_1.u128,
    SetInitialInvitationCount: types_1.u32,
    SetMembershipLeadInvitationQuota: types_1.u32,
    SetReferralCut: types_1.u8,
    CreateBlogPost,
    EditBlogPost,
    LockBlogPost: common_1.PostId,
    UnlockBlogPost: common_1.PostId,
    VetoProposal: ProposalId,
}) {
}
exports.ProposalDetails = ProposalDetails;
// Discussions
class ThreadAuthorId extends common_1.MemberId {
}
exports.ThreadAuthorId = ThreadAuthorId;
class PostAuthorId extends common_1.MemberId {
}
exports.PostAuthorId = PostAuthorId;
class ThreadMode extends (0, common_1.JoyEnum)({
    Open: types_1.Null,
    Closed: types_1.Vec.with(common_1.MemberId),
}) {
}
exports.ThreadMode = ThreadMode;
class DiscussionThread extends (0, common_1.JoyStructDecorated)({
    activated_at: types_1.u32,
    author_id: ThreadAuthorId,
    mode: ThreadMode,
}) {
}
exports.DiscussionThread = DiscussionThread;
class DiscussionPost extends (0, common_1.JoyStructDecorated)({
    author_id: PostAuthorId,
}) {
}
exports.DiscussionPost = DiscussionPost;
// export default proposalTypes;
exports.proposalsTypes = {
    ProposalId,
    ProposalStatus,
    ProposalOf: Proposal,
    ProposalDetails,
    ProposalDetailsOf: ProposalDetails,
    VotingResults,
    ProposalParameters,
    GeneralProposalParameters,
    VoteKind,
    DiscussionThread,
    DiscussionPost,
    CreateOpeningParameters,
    FillOpeningParameters,
    TerminateRoleParameters,
    ProposalDecision,
    ExecutionFailed,
    Approved,
    SetLeadParams,
    ThreadMode,
    ExecutionStatus,
    FundingRequestParameters,
};
exports.default = exports.proposalsTypes;
